export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/c2c3dd08cceb-tooliconairplanequestion.jpg',
  },
  title: 'Which airline were you flying with?',
}
